import { User } from 'lib/generated/graphql';
import InviteLinkBox from '../InviteLinkBox';
import SuccessfulInvites from '../SuccessfulInvites';

const FounderInvites = ({ user }: { user: User }) => {
  return (
    <div data-testid="startup-invites">
      <InviteLinkBox user={user} referralType="FOUNDER" />
      <SuccessfulInvites user={user} referralType="FOUNDER" />
    </div>
  );
};

export default FounderInvites;
